<template>
  <v-dialog v-model="dialog" persistent max-width="600" :fullscreen="$vuetify.breakpoint.smAndDown">
    <ExecutionResultsDialog title="Alias Separation" @close="close()" ref="executionResultsDialog" />
    <v-card v-if="dialog">
      <v-toolbar dense dark color="primary">
        <v-toolbar-title v-if="!isDepthHeight">
          Separate alias {{synonymName}}?
        </v-toolbar-title>
        <v-toolbar-title v-else>
          Separate depth alias {{synonymName}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-alert key="alert" outline class="my-0" type="error" :value="matchesLocationName">
        <div class="primary--text">
          The alias name cannot be separated because it matches the location name. Please rename the location before
          separating this alias.
        </div>
      </v-alert>
      <v-card-text class="pb-0" v-if="!isDepthHeight">
        <p>
          The alias {{ synonymName }} will be created as a separate data source with no QA/QC status.
        </p>
      </v-card-text>
      <v-card-text class="pb-0" v-else>
        The alias {{synonymName}} will be created as a separate data source with a Regular Alias. Its previously
        assigned depth values will not
        be changed.
      </v-card-text>
      <v-card-text class="pt-0">
        <v-checkbox color="info" v-model="formObject.assignToLocation" label="Assign to a location" persistent-hint hint="The alias will automatically be assigned to an existing or new location based on its name." />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" :disabled="matchesLocationName" :loading="loading" @click="submit()">
          <v-icon>call_split</v-icon>
          Separate
        </v-btn>
        <v-btn outline color="secondary" @click="dialog = false" :disabled="loading">
          {{ $t('Button.Cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const stationmetadata = createNamespacedHelpers('stationmetadata')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')
  const synonyms = createNamespacedHelpers('synonyms')
  const navigation = createNamespacedHelpers('navigation')

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  export default {
    props: {
      station: {
        type: Object,
        default: () => {},
      },
      isDepthHeight: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        synonym: null,
        loading: false,
        dialog: false,
        formObject: {
          assignToLocation: true,
        },
      }
    },
    computed: {
      ...stationmetadata.mapGetters(['stationMetadata', 'metaDataOrdinalStartIndex']),
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceIndexByType', 'currentMonitoringFeature']),
      ...dataSources.mapGetters(['dataSources', 'dataSourceIndex']),
      currentDiscreteDataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.discreteEnvirodata]
      },
      discreteStationsIndex() {
        return this.dataSourceIndex[SOURCE_TYPES.discreteEnvirodata]
      },
      currentDiscreteStation() {
        return this.discreteStationsIndex[this.currentDiscreteDataSource.SourceId]
      },
      locationName() {
        return this.currentMonitoringFeature.DisplayName
      },
      synonymName() {
        return this.synonym.Name
      },
      matchesLocationName() {
        return this.locationName == this.synonymName
      },
    },
    methods: {
      ...synonyms.mapActions(['removeSynonym']),
      ...stationmetadata.mapActions(['deleteMetaData', 'updateMetaData', 'addMetaData']),
      ...monitoringFeatures.mapActions(['fetchMonitoringFeaturesUI', 'refreshCurrentMFDetails']),
      ...dataSources.mapActions(['fetchDataSources']),
      ...navigation.mapActions(['fetchSideMenu']),
      show(synonym) {
        this.synonym = synonym
        this.dialog = true
      },
      close() {
        this.loading = false
        this.dialog = false
      },
      async submit() {
        this.loading = true

        try {
          const payload = {
            sourceId: this.currentDiscreteStation.Id,
            synonymName: this.synonymName,
            sourceType: SOURCE_TYPES.discreteEnvirodata,
            assignToLocation: this.formObject.assignToLocation,
          }

          let executionResults = await this.removeSynonym(payload)
          this.$refs.executionResultsDialog.show(executionResults)

          let a = this.fetchDataSources({
            sourceTypes: [SOURCE_TYPES.discreteEnvirodata],
          })

          let b = this.fetchMonitoringFeaturesUI()

          let c = this.refreshCurrentMFDetails({
            sourceTypes: [SOURCE_TYPES.discreteEnvirodata],
          })

          let d = this.fetchSideMenu()

          await Promise.all([a, b, c, d])

        } catch (error) {
          console.error(error)
          this.$refs.executionResultsDialog.show(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>